import React from 'react'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import WallboxSettingsFormGridContainer from './WallboxSettingsFormGridContainer'
import WallboxSettingsFormGridItem from './WallboxSettingsFormGridItem'
import { AuthFieldSet, CommonFieldSet, HysteresisFieldSet, NetworkFieldSet, OcppFieldSet } from '../tiles'
import { Grid } from '@mui/material'
import { WallboxOcppModel } from 'src/Libs/wallboxes/models'
import { supportsCableLockForWallbox, supportsLedIntensityForWallbox } from 'src/Libs/wallboxes/utils/wallbox-setting-software-support'

interface Props {
  model: WallboxConfigurationModel
  ocppSettings: WallboxOcppModel | null
  ocppError: Error | null
  softwareVersion?: string
  hasWritingAccess: boolean
}

/**
 * Efy Wallbox settings from (also called Witty)
 *
 * @param models
 * @param ocppSettings
 * @param ocppError
 * @param hasWritingAccess
 */
const WallboxSettingsEfyForm: React.FC<Props> = ({ model, ocppSettings, ocppError, softwareVersion, hasWritingAccess }) => {
  const hasCableLock = supportsCableLockForWallbox(softwareVersion)
  const hasLedIntensity = supportsLedIntensityForWallbox(softwareVersion)

  return (
    <SettingsFormContainer model={model}>
      <WallboxSettingsFormGridContainer>
        {softwareVersion !== undefined && (
          <WallboxSettingsFormGridItem>
            <CommonFieldSet model={model} disabled={!hasWritingAccess} hasCableLock={hasCableLock} hasLedIntensity={hasLedIntensity} />
          </WallboxSettingsFormGridItem>
        )}
        <WallboxSettingsFormGridItem>
          <HysteresisFieldSet model={model} disabled={!hasWritingAccess} />
        </WallboxSettingsFormGridItem>
        <Grid item xs={12}>
          <AuthFieldSet model={model} disabled={!hasWritingAccess} hasKeyLockMode={false} rfidReaderDisabled />
        </Grid>
        <Grid item xs={12}>
          <NetworkFieldSet model={model} disabled={!hasWritingAccess} />
        </Grid>

        {(ocppSettings || ocppError) && (
          <WallboxSettingsFormGridItem>
            <OcppFieldSet disabled={!hasWritingAccess} error={ocppError} />
          </WallboxSettingsFormGridItem>
        )}
      </WallboxSettingsFormGridContainer>
    </SettingsFormContainer>
  )
}

export default WallboxSettingsEfyForm
